import React, { useState } from 'react';
import { useLoginFormStyle } from '../css/useLoginFormStyle';
import MyEirLoginOperation from './MyEirLoginOperation';
import AccountSelection from './AccountSelection';
import MFAOtpScreen from './MFAOtpScreen';
import MFAContactNumScreen from './MFAContactNumScreen';

const LoginContainer = props => {
    const [loginScreen, setLoginScreen] = useState(props.screen ? props.screen : 0);
    const [otpUuid, setOtpUuid] = useState('');
    const [selectedContact, setSelectedContact] = useState('');
    const [username, setUsername] = useState('');
    const [loginOperationValue, setLoginOperationValue] = useState(null);
    const [waitingApiRes, setWaitingApiRes] = useState(false);
    const styleClasses = useLoginFormStyle();
    function handleBackButton(value) {
        if (value) {
            setLoginScreen(loginScreen - value);
        } else {
            setLoginScreen(loginScreen - 1);
        }
    }
    return (
        <>
            <div className={styleClasses.loginContainer}>
                {
                    {
                        0: (
                            <MyEirLoginOperation
                                loginScreen={loginScreen}
                                setLoginScreen={setLoginScreen}
                                setOtpUuid={setOtpUuid}
                                setUsername={setUsername}
                                setLoginOperationValue={setLoginOperationValue}
                                setWaitingApiRes={setWaitingApiRes}
                                flag={props.flag}
                            />
                        ),
                        1: (
                            <AccountSelection
                                loginScreen={loginScreen}
                                setLoginScreen={setLoginScreen}
                                handleBackButton={handleBackButton}
                            />
                        ),
                        2: (
                            <MFAContactNumScreen
                                loginScreen={loginScreen}
                                setLoginScreen={setLoginScreen}
                                handleBackButton={handleBackButton}
                                otpUuid={otpUuid}
                                username={username}
                                loginOperation={loginOperationValue}
                                setWaitingApiRes={setWaitingApiRes}
                                setSelectedContact={setSelectedContact}
                            />
                        ),
                        3: (
                            <MFAOtpScreen
                                loginScreen={loginScreen}
                                setLoginScreen={setLoginScreen}
                                handleBackButton={handleBackButton}
                                otpUuid={otpUuid}
                                username={username}
                                loginOperation={loginOperationValue}
                                setWaitingApiRes={setWaitingApiRes}
                                selectedContact={selectedContact}
                            />
                        ),
                    }[loginScreen]
                }
            </div>
        </>
    );
};
export default LoginContainer;
